var _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M1 11H20C20.5523 11 21 11.4477 21 12V18C21 18.5523 20.5523 19 20 19H1V11Z",
    fill: "#AFB8C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bright-fill",
    width: 12,
    height: 8,
    transform: "translate(1 11)",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M1 23H32C32.5523 23 33 23.4477 33 24V30C33 30.5523 32.5523 31 32 31H1V23Z",
    fill: "#AFB8C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "bright-fill",
    width: 20,
    height: 8,
    transform: "translate(1 23)",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBar);
export default __webpack_public_path__ + "static/media/stacked-bar.c83e1c10dff75ec59a7d2dd5e045b7cc.svg";
export { ForwardRef as ReactComponent };